export default __webpack_public_path__ + "static/media/crop.ced07692.svg";